"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var AjaxProvider_1 = __importDefault(require("@/functions/AjaxProvider"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var AppTemplateEditor_module_css_1 = __importDefault(require("./AppTemplateEditor.module.css"));
var react_i18next_1 = require("react-i18next");
var GenericSnackbar_1 = __importDefault(require("../GenericSnackbar"));
var AppTemplateTranslationsTab = function (_a) {
    var appTemplateData = _a.appTemplateData, onTranslationsUpdate = _a.onTranslationsUpdate;
    var dataProvider = (0, AjaxProvider_1.default)("/api");
    var logger = q_play_core_1.logManager.getLogger();
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _b = (0, react_1.useState)(JSON.stringify(Array.isArray(appTemplateData.translations) && appTemplateData.translations.length === 0
        ? {}
        : appTemplateData.translations, null, 2)), translationsText = _b[0], setTranslationsText = _b[1];
    var _c = (0, react_1.useState)(null), error = _c[0], setError = _c[1];
    var _d = (0, react_1.useState)(false), isSaving = _d[0], setIsSaving = _d[1];
    var _e = (0, react_1.useState)(false), snackbarOpen = _e[0], setSnackbarOpen = _e[1];
    var _f = (0, react_1.useState)(""), snackbarMessage = _f[0], setSnackbarMessage = _f[1];
    var _g = (0, react_1.useState)("success"), snackbarSeverity = _g[0], setSnackbarSeverity = _g[1];
    var validateTranslations = function (translations) {
        try {
            if (typeof translations !== "object" || translations === null) {
                throw new Error(t("Translations must be a valid object ({})."));
            }
            for (var _i = 0, _a = Object.entries(translations); _i < _a.length; _i++) {
                var _b = _a[_i], language = _b[0], translationSet = _b[1];
                if (!["da", "en"].includes(language)) {
                    throw new Error(t("Unsupported language: ".concat(language, ".")));
                }
                if (typeof translationSet !== "object" ||
                    !Object.entries(translationSet).every(function (_a) {
                        var key = _a[0], value = _a[1];
                        return typeof key === "string" && typeof value === "string";
                    })) {
                    throw new Error(t("Invalid translations for language: ".concat(language, ". Must be a key-value pair object ({}).")));
                }
            }
            return true;
        }
        catch (e) {
            setError(e.message);
            return false;
        }
    };
    var handleTextareaChange = function (e) {
        var newValue = e.target.value;
        setTranslationsText(newValue);
        try {
            var parsed = JSON.parse(newValue);
            if (validateTranslations(parsed)) {
                setError(null);
            }
        }
        catch (_a) {
            setError(t("Invalid JSON format."));
        }
    };
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var parsedTranslations, isTranslationsEmpty, resource, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (error)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    setIsSaving(true);
                    parsedTranslations = JSON.parse(translationsText);
                    if (!validateTranslations(parsedTranslations)) {
                        setIsSaving(false);
                        return [2 /*return*/];
                    }
                    isTranslationsEmpty = (!parsedTranslations.da || Object.keys(parsedTranslations.da).length === 0) &&
                        (!parsedTranslations.en || Object.keys(parsedTranslations.en).length === 0);
                    if (isTranslationsEmpty) {
                        parsedTranslations = {};
                    }
                    else {
                        parsedTranslations = {
                            da: typeof parsedTranslations.da === "object" && !Array.isArray(parsedTranslations.da)
                                ? parsedTranslations.da
                                : {},
                            en: typeof parsedTranslations.en === "object" && !Array.isArray(parsedTranslations.en)
                                ? parsedTranslations.en
                                : {},
                        };
                    }
                    resource = "app-template-editor/app-template-versions/".concat(appTemplateData.id, "/").concat(appTemplateData.current_version, "/translations");
                    return [4 /*yield*/, dataProvider.update(resource, {
                            id: "",
                            data: { translations: parsedTranslations },
                            previousData: {},
                        })];
                case 2:
                    _a.sent();
                    onTranslationsUpdate && onTranslationsUpdate(parsedTranslations);
                    setSnackbarMessage(t("Translations saved successfully."));
                    setSnackbarSeverity("success");
                    setSnackbarOpen(true);
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    logger.error("Error updating translations:", err_1);
                    setSnackbarMessage(t("Failed to save translations. Please try again."));
                    setSnackbarSeverity("error");
                    setSnackbarOpen(true);
                    return [3 /*break*/, 5];
                case 4:
                    setIsSaving(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["translations-container"] },
            react_1.default.createElement("textarea", { className: AppTemplateEditor_module_css_1.default["translations-textarea"], value: translationsText, onChange: handleTextareaChange, rows: 6 }),
            error && react_1.default.createElement("p", { className: AppTemplateEditor_module_css_1.default["error-message"] }, error),
            react_1.default.createElement("div", { style: { marginTop: "15px", textAlign: "right" } },
                react_1.default.createElement(q_play_components_1.Button, { text: isSaving ? t("Saving...") : t("Save"), onClick: handleSave, style: { width: "100%" }, disabled: isSaving || !!error }))),
        react_1.default.createElement(GenericSnackbar_1.default, { open: snackbarOpen, onClose: function () { return setSnackbarOpen(false); }, message: snackbarMessage, severity: snackbarSeverity })));
};
exports.default = AppTemplateTranslationsTab;
